import { I18nLocale } from 'utils';

import { VatType } from '@/modules/checkout/api';
import { BaseProduct } from '@/shared/types/base-product';

export type User = {
  email: string;
  customerId: string;
  locale: I18nLocale;
  name: string | null;
  companyName: string | null;
  companyIdentificationNumber: string | null;
  city: string | null;
  address: string | null;
  addressNumber: string | null;
  zipCode: string | null;
  phone: string | null;
  birthdayDate: { date: string } | null;
};

export type SignUpPayload = {
  email: string;
  plainPassword: string;
};

type CustomerResponse = {
  customerId: string;
  locale: I18nLocale;
};

export type SignUpResponse = CustomerResponse;

export type SignInPayload = {
  email: string;
  plainPassword: string;
};

type TokenResponse = {
  accessToken: string;
  accessTokenExpiresIn: number;
  refreshToken: string;
  refreshTokenExpiresIn: number;
};

export type SignInResponse = TokenResponse;

export type RefreshTokenResponse = TokenResponse;

export type AccountShowResponse = {
  customer: User;
};

export type ForgotPasswordResponse = CustomerResponse;

export type ForgotPasswordConfirmPayload = {
  confirmationCode: string;
  newPassword: string;
};

export enum AccountOrderDetailsStatus {
  PENDING_PAYMENT = 'pendingPayment',
  IN_PROGRESS = 'inProgress',
  IN_COMPLEMENTATION = 'inComplementation',
  SHIPPED = 'shipped',
  DELIVERED = 'delivered',
  CANCELED = 'canceled',
}

export type AccountOrderDetails = {
  orderId: string;
  number: string;
  locale: I18nLocale;
  vatType: VatType;
  status: AccountOrderDetailsStatus;
  email: string;
  payment: {
    id: string;
    code: string;
    name: string;
    paid: {
      amount: number;
      currency: string;
    };
    type: string;
    price: {
      amount: number;
      currency: string;
    };
    status: string;
  };
  shipping: {
    code: string;
    name: string;
    price: {
      amount: number;
      currency: string;
    };
  };
  customer: {
    name: string;
    phone: string;
  };
  customerComment: string;
  delivery: {
    city: string;
    name: string;
    point: {
      id: string;
      name: string;
    };
    address: string;
    company: string;
    zipcode: string;
  };
  companyInvoice: {
    city: string;
    name: string;
    address: string;
    zipcode: string;
    taxIdentification: string;
  };
  amount: {
    amount: number;
    currency: string;
  };
  products: [
    BaseProduct & {
      ean: string;
      price: {
        amount: number;
        currency: string;
      };
      amount: {
        amount: number;
        currency: string;
      };
      vatRate: number;
      quantity: number;
      productId: string;
      imageBase64: string;
      shippingTime: number;
    },
  ];
  estimateDeliveryDate: string;
  orderedAt: string;
  paymentMonitStatus: string;
};

export type AccountOrdersListResponse = {
  count: number;
  data: AccountOrderDetails[];
};

export type CustomerDetailsUpdatePayload = {
  name: string | null;
  birthdayDate: string | null;
};

export type ChangePasswordPayload = {
  oldPassword: string;
  newPassword: string;
};

export type ChangePasswordResponse = TokenResponse;
